import {ReportModel} from "@fedeltapointofsale/data-client";
import {
    SalesByCategoryReportData} from "./sales-by-category-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SalesByCategoryReportModel extends ReportModel<SalesByCategoryReportData> {
    constructor(injector: Injector) {
        super(injector, SalesByCategoryReportData);
    }
}
